import React from 'react';
import PropTypes from 'prop-types';

const Switch = ({ checked, onChecked, customClass, ...otherProps }) => {
  return (
    <label className={`switch ${customClass}`}>
      <input
        type='checkbox'
        checked={checked}
        onChange={(event) => onChecked(event.target.checked)}
        {...otherProps}
      />
      <span className='slider round'></span>
    </label>
  );
};

Switch.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChecked: PropTypes.func.isRequired,
};

Switch.defaultProps = {
  customClass: '',
};

export default Switch;
